import {
  useGetPartnerQuery,
  usePostPartnerMutation,
} from '@/api/api.slice.tsx';
import { AccountSide } from '@/features/OnBoarding/StepReview/AccountSide.tsx';
import { PaymentSide } from '@/features/OnBoarding/StepReview/PaymentSide.tsx';
import {
  Alert,
  Button,
  getMessageFromError,
} from '@arsnovasystems/ars-front-lib';
import DoneOutlineRoundedIcon from '@mui/icons-material/DoneOutlineRounded';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

/**
 * StepReview
 *
 * @returns JSX of the component
 */
export const StepReview = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: me } = useGetPartnerQuery();
  const [savePartnerTrigger, savePartnerResult] = usePostPartnerMutation();

  const handleNext = async () => {
    const res = await savePartnerTrigger({
      ...me,
      signUpStatus: 'complete',
    });

    if (res.error === undefined) {
      void navigate('/onboarding/step/last/success');
    }
  };

  return (
    <>
      <Stack
        direction={'row'}
        sx={{
          gap: 2,
          width: 'stretch',
        }}
      >
        <AccountSide />
        <PaymentSide />

        {savePartnerResult.error ?
          <Alert>{getMessageFromError(savePartnerResult.error)}</Alert>
        : null}
      </Stack>
      <Stack
        direction={'row'}
        sx={{ justifyContent: 'center', gap: 3, marginTop: 3 }}
      >
        <Button
          onClick={() => {
            void navigate(
              `/onboarding/step/means-of-payments${location.search}`,
            );
          }}
          size={'large'}
          variant={'outlined'}
        >
          {t('Back')}
        </Button>
        <Button
          disabled={savePartnerResult.isLoading}
          size={'large'}
          onClick={() => {
            void handleNext();
          }}
          endIcon={<DoneOutlineRoundedIcon />}
        >
          {t('Finish')}
        </Button>
      </Stack>
    </>
  );
};
